export const playgroundActionUpdateMethods = (updateMethods: any) => {
  return Object.keys(updateMethods)
    .map((method) => ({
      [method]: (member: any, values: any, ...rest: any) => {
        return updateMethods[method].apply(null, [member, values, ...rest]);
      },
    }))
    .reduce((a, b) => ({ ...a, ...b }), {});
};
